import {
  getSessionToken,
  isSessionTokenExpired,
  refresh,
} from '@descope/react-sdk';

export class ApiRepository {
  /**
   * The bearer token for an API call: the Descope session token (PPL-3826).
   * The API validates it directly, so the UI sends it instead of the Firebase
   * ID token. Refresh it first when it has expired, so a call late in a
   * session does not go out with a stale token and 401.
   */
  protected async getToken(): Promise<string | undefined> {
    let token = getSessionToken();
    if (!token || isSessionTokenExpired(token)) {
      try {
        await refresh();
      } catch {
        // No live session to refresh, or the refresh failed: treat it as
        // unauthenticated rather than letting the rejection bubble through
        // every call site. The call goes out without a bearer and gets 401.
        return undefined;
      }
      token = getSessionToken();
    }
    return token || undefined;
  }
}
